/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_Q4Inputs */

const en_pc_faq_q4 = /** @type {(inputs: Pc_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can PdfCraft replace Adobe Acrobat?`)
};

const zh_pc_faq_q4 = /** @type {(inputs: Pc_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 能替代 Adobe Acrobat 吗？`)
};

/**
* | output |
* | --- |
* | "Can PdfCraft replace Adobe Acrobat?" |
*
* @param {Pc_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_q4 = /** @type {((inputs?: Pc_Faq_Q4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_Q4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_q4(inputs)
	return zh_pc_faq_q4(inputs)
});
export { pc_faq_q4 as "pc.faq.q4" }